import React from 'react';

import Styles from './HeroHeader.module.scss';

type TProps = {
  children: React.ReactNode;
  withOverlay?: boolean;
};

const HeroHeader = ({ children, withOverlay = true }: TProps) => (
  <div className={`${Styles.Wrapper} heroBackgroundImage`}>
    {withOverlay && <div className={Styles.Overlay} />}
    <div className={Styles.Content}>{children}</div>
  </div>
);

export default HeroHeader;
